module.exports = __webpack_public_path__ + "static/media/logo.bb5dd187.png";